import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import * as common from "@/javascripts/common.js";

// Connects to data-controller="drawer"
export default class extends Controller {
  static targets = ["drawer", "content"];

  connect() {
    if (this.hasContentTarget) {
      this.drawerTarget.addEventListener("click", this.overlayClick.bind(this));
    }
    // Escキーで閉じる
    this.drawerTarget.addEventListener("cancel", this.#cancel);
  }

  disconnect() {
    // 戻る・進むボタンでの遷移時のために後始末する
    this.closeWithoutFade();
  }

  // ドロワーを開く
  open() {
    const drawer = this.drawerTarget;
    drawer.showModal();
    drawer.setAttribute("tabindex", "-1");
    drawer.focus();
    $(drawer).fadeIn(300).addClass("is-open");
    common.HtmlFix();
  }

  // ドロワーを閉じる
  close(callback) {
    this.#openingDrawers().forEach((drawer) => {
      $(drawer)
        .fadeOut(300, () => {
          drawer.close();
          if (typeof callback === "function") callback(drawer);
        })
        .removeClass("is-open");
    });
    common.HtmlScroll();
  }

  // フェードせずにドロワーを閉じる
  closeWithoutFade() {
    this.#openingDrawers().forEach((drawer) => {
      drawer.close();
    });
    common.HtmlScroll();
  }

  // オーバーレイクリック時の処理
  overlayClick(event) {
    if (!this.contentTarget.contains(event.target)) {
      this.close();
    }
  }

  #openingDrawers() {
    return [...document.getElementsByClassName("js-drawer is-open"), ...this.drawerTargets];
  }

  // Escキーで閉じる
  #cancel = (e) => {
    e?.preventDefault();
    this.close();
  };
}

/**
 * 離れた場所からdrawerを開閉するボタン
 * @example
 * <button
 *   data-controller="drawer-button"
 *   data-drawer-button-drawer-outlet="#drawer"
 *   data-action="drawer-button#open">開く</button>
 * <dialog id="drawer" data-controller="drawer">...</dialog>
 */
export class DrawerButtonController extends Controller {
  static outlets = ["drawer"];

  open() {
    for (const drawer of this.drawerOutlets) drawer.open();
  }
  close() {
    for (const drawer of this.drawerOutlets) drawer.close();
  }
}
